import { Box, Text } from '@chakra-ui/react';
import { ComponentImages } from '@cms/graphql/types.generated';
import { LazyImage } from '@meritcircle/ui/components';

type Props = Pick<ComponentImages, 'image1' | 'description1' | 'image2' | 'description2'>;
interface ImageWithDescriptionProps {
  url: string;
  description?: string;
  imageTitle: string;
  imageDescription: string;
}

const ImageWithDescription = ({
  url,
  description,
  imageTitle,
  imageDescription,
}: ImageWithDescriptionProps) => (
  <Box
    width="100%"
    _last={{
      mt: ['xl', 0],
    }}>
    <LazyImage
      objectFit="cover"
      borderRadius="lg"
      src={url}
      placeholderUrl={`${url}?w=30`}
      w="100%"
      alt={imageDescription || description || imageTitle}
    />
    {description && (
      <Text color="muted" fontSize="xs" mt="xs" textAlign="right">
        {description}
      </Text>
    )}
  </Box>
);

export const ArticleImage: React.FC<Props> = ({ image1, image2, description1, description2 }) => {
  return (
    <Box mt={['xl', null, '2xl']} display={['inherit', null, 'flex']} gap="md">
      {!!image1?.url && (
        <ImageWithDescription
          url={image1.url}
          description={description1}
          imageTitle={image1.title}
          imageDescription={image1.description}
        />
      )}
      {!!image2?.url && (
        <ImageWithDescription
          url={image2.url}
          description={description2}
          imageTitle={image1.title}
          imageDescription={image1.description}
        />
      )}
    </Box>
  );
};
